import { render, staticRenderFns } from "./ModalAppeal.vue?vue&type=template&id=30143957"
import script from "./ModalAppeal.vue?vue&type=script&lang=js"
export * from "./ModalAppeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports